module.exports = __webpack_public_path__ + "img/toon-link-min.409254c9.png";